export const frontPages = (params) => {
  let all = params.all;
  let curPage = params.curPage || 1;
  let pageSize = params.pageSize || 20;
  let total = params.total || params.all.length;
  return all.slice((curPage - 1) * pageSize, curPage * pageSize);
};



// WEBPACK FOOTER //
// ./src/service/frontPages.js